<template>
  <input-base
      ref="input"
      :validated-field="validatedField"
      :field-config="fieldConfig"
      :read-only="readOnly"
      :editor-mode="editorMode"
      :grid-editor="gridEditor"
  >
    <template slot="editor">
      <DateTimePicker
          v-model="validatedField.value"
          :placeholder="fieldConfig.formPlaceholder"
          :min-date="minDate"
          :max-date="maxDate"
          :format="fieldConfig.format"
          :useCurrent="fieldConfig.useCurrent"
          :excludedDays="excludedDays"
          :excludedHours="fieldConfig.excludedHours"
          :excludedWeekends="fieldConfig.excludedWeekends"
          :dateType="fieldConfig.dateType"
          :customFocusOnHide="customFocusOnHide"
          :excludedDayField="fieldConfig.excludedDayField"
          :validated-field="validatedField"
          @update-excluded-days="updateExcludedDays"
      >
      </DateTimePicker>
    </template>

    <template slot="readOnly">
      {{ formattedValue }}
    </template>
  </input-base>
</template>


<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import TextPillsList from "@/components/inputs/controls/TextPillsList";
import InputBase from "@/components/inputs/InputBase";
import DateFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/DateFormFieldConfig";
import DateTimePicker from "@/components/inputs/DateTimePicker";
import moment from "moment-timezone";
import LocalDateTime from "@/server/LocalDateTime";

moment.suppressDeprecationWarnings = true;

export default {
  name: "DateSelectRenderer",
  components: {DateTimePicker, TextPillsList, InputBase},

  async created() {

  },

  async mounted() {
    if (this.fieldConfig.minDateConverted?.value) {
      this.minDate = this.fieldConfig.minDateConverted.value;
    }
    if (this.fieldConfig.maxDateConverted?.value) {
      this.maxDate = this.fieldConfig.maxDateConverted.value;
    }
    if (this.fieldConfig.dateSelectionFromToday) {
      this.minDate = new Date().toJSON().slice(0, 10);
    }
    this.formatterValueForLocal();
    this.formatterValueForInstant();

    if (this.fieldConfig.excludedDaysConverted) {
      this.excludedDays = this.fieldConfig.excludedDaysConverted;
    }

    // this.validatedField.validatedForm.originalSource
    // });
  },

  methods: {

    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    setEditorMode(val) {
      this.editorMode = val;
    },

    updateExcludedDays(val) {
      if (val?.length) {
        val = val.slice(1, -1).split(",");
      }
      this.excludedDays = val;
    },

    formatterValueForLocal() {
      if (this.validatedField.value?.value || this.validatedField.value) {
        let val = this.validatedField.value?.value;
        if (!val) {
          val = this.validatedField.value;
        }
        if (this.fieldConfig.dateType === "LocalDateTime" || this.fieldConfig.dateType === "LocalDate") {
          this.formattedValue = moment(val).format(this.fieldConfig.format);
        } else if (this.fieldConfig.dateType === "LocalTime") {

          this.formattedValue = moment(this.validatedField.value.value, "HH:mm:ss").format(this.fieldConfig.format);
        }
      } else {
        this.formattedValue = null;
      }
    },

    formatterValueForInstant() {
      if (this.validatedField.value) {
        if (this.fieldConfig.dateType === "Instant") {
          this.formattedValue = moment(this.validatedField.value, "HH:mm:ss").format(this.fieldConfig.format);
        }
      } else {
        this.formattedValue = null;
      }
    }
  },

  props: {
    customFocusOnHide: {default: null},
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: DateFormFieldConfig, required: true},
    openFromGrid: {default: false},
    gridEditor: {default: null},
  },


  watch: {
    "validatedField.value.value": function () {
      this.formatterValueForLocal();
    },
    "validatedField.value": function () {
      this.formatterValueForInstant();
    },

    "validatedField.validatedForm.originalSource": function (val) {
      if (this.fieldConfig.excludedDayField) {
        this.validatedField.onChangeDelayed(async () => {
          await val.refreshComputed(this.validatedField.validatedForm.formConfig);
          let excludedDays = val?.__computed__?.excludedDays;
          if (excludedDays) {
            this.updateExcludedDays(excludedDays);
          }
        });
      }
    },

    "fieldConfig.excludedDaysConverted": function (val) {
      this.excludedDays = val;
    }
  },

  data: () => ({
    readOnly: true,
    editorMode: false,
    formattedValue: "",
    minDate: null,
    maxDate: null,
    excludedDays: null,
  })
}
</script>
